import React, { useContext } from "react";
import { Link } from "gatsby";
import PageContext from "@contexts/page";

const L = ({ to, ...rest }) => {
  const { location, locale } = useContext(PageContext);
  // const { pathname } = location;
  //
  // const isPrefixed =
  //   pathname === `/${locale}` || pathname.startsWith(`/${locale}/`);
  //
  // if (isPrefixed) to = `/${locale}${to}`;

  return <Link to={to} {...rest} />;
};

export default L;
